<template>
  <nav aria-label="Breadcrumb">
    <ol class="ucrs-breadcrumbs">
      <li
        v-for="(item, index) in items"
        :key="index"
        :class="[
          'ucrs-breadcrumbs__item',
          { 'ucrs-breadcrumbs__item-mobile': isMobileItem(index) },
        ]"
        tabindex="-1"
      >
        <NuxtLink
          v-if="index !== items.length - 1"
          v-slot="{ navigate }"
          class="ucrs-breadcrumbs__itemLink"
          :to="item[url]"
          custom
        >
          <span>
            <SvgIcon
              name="angle-left"
              class="inline w-4 min-w-4 h-4 mr-2 md:hidden"
            />
            <a
              v-dompurify-html="item[label]"
              :href="item[url]"
              @click="onBreadcrumbClick(navigate, $event)"
            />
          </span>
        </NuxtLink>
        <a v-else v-dompurify-html="item[label]" href="" aria-current="page" />
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [
          {
            label: 'Home',
            url: '/',
          },
        ]
      },
    },

    label: {
      type: String,
      default: 'text',
    },

    url: {
      type: String,
      default: 'href',
    },
  },

  methods: {
    isMobileItem(index) {
      const itemsLength = this.items.length

      if (
        (itemsLength >= 2 && index === itemsLength - 3) ||
        (itemsLength === 2 && index === 0)
      ) {
        return true
      }

      return false
    },

    onBreadcrumbClick(navigate, payload) {
      const documentReferrer = document.referrer
      const historyLength = window.history.length
      const isMobileView = window.innerWidth <= 768

      if (isMobileView && documentReferrer && historyLength <= 2) {
        window.close()
        return
      }

      navigate(payload)
    },
  },
}
</script>

<style lang="postcss" scoped>
.ucrs-breadcrumbs {
  @apply flex justify-start flex-wrap text-lg py-6.4;

  &__item {
    @apply hidden;

    &-mobile {
      @apply block truncate md:overflow-visible;
    }

    @screen md {
      @apply inline-block;

      &:not(:last-child)::after {
        content: '/';

        @apply inline-block mx-2 text-gray-light;
      }
    }

    a:focus-visible {
      @apply outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:rounded focus-visible:ring-blue;
    }
  }

  &__itemLink {
    @apply items-center font-bold uppercase;

    @screen md {
      @apply font-normal normal-case text-blue underline;
    }

    a:focus-visible {
      @apply outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:rounded focus-visible:ring-blue;
    }
  }
}
</style>
